
interface FooterProps {
  scrollToSection: (sectionId: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  return (
    <footer className="bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Brand */}
        <div className="mb-16">
          <h2 className="text-6xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
            Cows4Christ
          </h2>
        </div>

        {/* Three Columns */}
        <div className="grid grid-cols-3 gap-16 mb-16">
          {/* Left Column - Mission & Social */}
          <div>
            <p className="text-base leading-relaxed mb-10 max-w-sm">
              Honoring God through faithful stewardship of His creation. We raise longhorn cattle with devotion and serve our community with love, demonstrating Christian values in everything we do.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border-2 border-white rounded-full hover:bg-white hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Contact Info */}
          <div>
            <div className="mb-12">
              <h3 className="text-xs uppercase tracking-wider mb-3 font-semibold">ADDRESS</h3>
              <p className="text-base">
                1099 Dailey Road<br />
                Altoona, Alabama 35952
              </p>
            </div>
            <div className="mb-12">
              <h3 className="text-xs uppercase tracking-wider mb-3 font-semibold">PHONE</h3>
              <p className="text-base">256.361.3344</p>
            </div>
            <div>
              <h3 className="text-xs uppercase tracking-wider mb-3 font-semibold">EMAIL</h3>
              <p className="text-base">info@cows4christ.org</p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div>
            <div className="w-full h-80 rounded-lg overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/b38cbfe3773d640a028cf30c9168fdbc.jpg" 
                alt="Ranch at sunset with cross" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-[#333333] pt-6">
          <div className="flex items-center justify-between">
            <p className="text-sm">© 2025 Cows4Christ. All rights reserved.</p>
            <div className="flex items-center gap-8">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white/80 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
              <button onClick={() => scrollToSection('home')} className="text-sm hover:text-white/80 transition-colors">
                Privacy Policy
              </button>
              <button onClick={() => scrollToSection('home')} className="text-sm hover:text-white/80 transition-colors">
                Terms
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
